module.exports = __webpack_public_path__ + "static/media/logoMaxiglobal.36e1c138.svg";